import { render } from "./MyPurchase.vue?vue&type=template&id=0d513573&scoped=true&ts=true&lang=pug"
import script from "./MyPurchase.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPurchase.vue?vue&type=script&setup=true&lang=ts"

import "./MyPurchase.vue?vue&type=style&index=0&id=0d513573&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d513573"]])

export default __exports__